export default "__VITE_ASSET__KO58PaWS__"